import { useEHRContext } from 'contexts/EHRContext';
import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { findTabObject, tabsInfo } from 'utils/patientSummary';
// import { formatISO2DisplayDateString } from 'utils/dateFunctions';
// import i18n from 'i18n';
import axios from 'axios';
import { logDebug, retrieveData } from 'utils/AuxiliarFunctions';
import xdsToken from 'services/xdsToken';
import { currentMode, endpoints } from 'configs';
import { toast } from 'react-toastify';
import { ToastMessage } from 'components';
import { TemplateTab } from '../TemplateTab/TemplateTab';

export function HospitalizationsTab() {
  const { t } = useTranslation('PatientSummary');
  const { patientSummary, ehrState } = useEHRContext();
  const [resourceRows, setResourceRows] = useState([]);
  const [nextPageLink, setNextPageLink] = useState({});
  const targetTab = 'hospitalizations';

  let tabResource = useMemo(() => (patientSummary), [patientSummary]);
  if (patientSummary?.entry) tabResource = findTabObject({ patientSummary, targetTab });

  async function getTokens() {
    await xdsToken.getBearerToken();
    const bearerToken = await retrieveData('application_token');
    const xUserToken = await retrieveData('token');
    return { bearerToken, xUserToken };
  }

  function handleGetMoreDocs() {
    if (typeof nextPageLink === 'object') {
      const link = `${endpoints.MHD}?${nextPageLink.url.split('?')[1]}`;

      getTokens().then((tokens) => {
        const headers = {
          authorization: `Bearer ${ehrState.subject.token || tokens.bearerToken}`,
          'x-user-Token': `${ehrState.subject.token || tokens.xUserToken}`,
          'Content-Type': 'application/fhir+json',
          Accept: 'application/fhir+json',
          purposeofuse: 'Atendimento',
          ...(ehrState.subject.organizationId && { 'organization-id': ehrState.subject.organizationId }),
          ...(ehrState.resource.id && currentMode === 'aghu' && { 'resource-id': ehrState.resource.id }),
          ...(ehrState.subject.id && { 'subject-id': ehrState.subject.id }),
        };
        axios({
          method: 'get', url: link, headers, timeout: 5000,
        })
          .then(async ({ data: response }) => {
            toast.success(<ToastMessage type="success"> Requisição completada.</ToastMessage>);
            setResourceRows([...resourceRows, ...response.entry.map((document) => ({
              id: document.resource.id,
              code: document.resource.extension[0].valueCodeableConcept.coding[0].code,
              description: document.resource.extension[0].valueCodeableConcept.text,
              date: document.resource.context.period.start,
              url: document.fullUrl,
              binaryId: document.resource?.masterIdentifier?.value?.split('urn:oid:')[1],
            }))]);
            setNextPageLink(response.link.find((itemLink) => itemLink.relation === 'next'));
          })
          .catch((err) => {
            try {
              logDebug(err);
              toast.error(<ToastMessage type="error"> Requisição completada.</ToastMessage>);
            } catch {
              // toast de error
            }
          });
      });
    }
  }

  useEffect(() => {
    if (tabResource?.resource) {
      setNextPageLink(tabResource.resource.link.find((link) => link.relation === 'next'));
      if (tabResource.resource.entry) {
        setResourceRows(tabResource.resource.entry.map((document) => ({
          id: document.resource.id,
          code: document.resource.extension[0].valueCodeableConcept.coding[0].code,
          description: document.resource.extension[0].valueCodeableConcept.text,
          date: document.resource.context.period.start,
          url: document.fullUrl,
          binaryId: document.resource?.masterIdentifier?.value?.split('urn:oid:')[1],
        })));
      } else setResourceRows([]);
    }
  }, [tabResource]);

  return (
    <>

      <TemplateTab table={resourceRows} name={t(tabsInfo[targetTab].name)} param="CID10" total={tabResource?.resource?.total} id={tabResource?.resource?.id} onGetMoreDocs={handleGetMoreDocs} />

    </>
  );
}
